export { default as TagSolidIcon } from './TagSolidIcon';
